import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { schedulesInternalTxnDetails } from "../../../redux/features/scheduleInternalTxn/index";
import TEXT from "../../../utils/globalText";
import { globalTextFormat } from "../../../utils/globalTextFormat";

const ScheduleInternalTransactionSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const services = useSelector((state) => state.refreshToken.services);
  const { schedulesInternalTxnDetailData } = useSelector(
    (state) => state.scheduleInternalTxnSlice,
  );

  const frequency = schedulesInternalTxnDetailData?.transaction?.[0]?.frequency;

  const capitalizedFrequency = frequency
    ? frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase()
    : "";

  const internalAccount = () => {
    const internalId =
      schedulesInternalTxnDetailData?.transaction?.[0]?.internal_account_id;

    navigate(
      `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${internalId}`,
    );
  };

  const sourceAccount = () => {
    const sourceId =
      schedulesInternalTxnDetailData?.transaction?.[0]?.owner_account_id;
    navigate(
      `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${sourceId}`,
    );
  };

  const formateDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "short",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };
  const createTxnHandler = () => {
    navigate("/internal_transaction_dashboard/create_schedule_transaction");
  };
  const viewDetailsHandler = () => {
    navigate(
      `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/internal_transaction_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create schedule",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: createTxnHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (id && services) {
      dispatch(schedulesInternalTxnDetails({ id, services, navigate }));
    }
  }, [id, services, dispatch, navigate]);

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          schedulesInternalTxnDetailData?.transaction?.[0]?.lifecycle_status ===
          "approved"
            ? TEXT.SCHEDULE_INTERNAL_CREATED_AND_APPROVED
            : TEXT.SCHEDULE_CREATED_SUCCESS
        }
        subtitle=""
      >
        <TabsWeapperSection
          title={globalTextFormat(TEXT?.TRANSFER_DETAILS, [0])}
        >
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.scheduled_name,
                  leftSubTitle: globalTextFormat(TEXT?.SCHEDULE_NAME, [0]),
                  hasRight: true,
                  rightText: true,
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          schedulesInternalTxnDetailData?.transaction?.[0]
                            ?.amount
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightTitleTextColor: "var(--text-primary)",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={sourceAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: globalTextFormat(
                    TEXT?.SOURCE_ACCOUNT_DETAILS,
                    [0],
                  ),
                  ifsc: schedulesInternalTxnDetailData?.transaction?.[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={internalAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.internal_account_bank_acc_no,
                  ),
                  leftSubTitle: globalTextFormat(
                    TEXT?.DESTINATION_ACCOUNT_DETAILS,
                    [0],
                  ),
                  ifsc: schedulesInternalTxnDetailData?.transaction?.[0]
                    ?.internal_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            {schedulesInternalTxnDetailData?.transaction?.[0]
              ?.confidential_transaction === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      schedulesInternalTxnDetailData?.transaction?.[0]
                        ?.confidential_transaction === "Y"
                        ? "Yes"
                        : "No",
                    leftSubTitle: globalTextFormat(
                      TEXT?.CONFIDENTIAL_TRANSACTION,
                      [0],
                    ),
                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.lifecycle_status === "pending"
                      ? "Pending"
                      : schedulesInternalTxnDetailData?.transaction?.[0]
                            ?.lifecycle_status === "approved"
                        ? "Created distribution"
                        : schedulesInternalTxnDetailData?.transaction?.[0]
                            ?.lifecycle_status,
                  leftSubTitle: globalTextFormat(TEXT?.TRANSACTION_STATUS, [0]),
                  icon:
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.lifecycle_status === "pending"
                      ? ICONS?.PENDING_BLUE
                      : schedulesInternalTxnDetailData?.transaction?.[0]
                            ?.lifecycle_status === "approved"
                        ? ICONS?.QUEUED
                        : ICONS?.LOADER,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        <TabsWeapperSection
          title={globalTextFormat(TEXT?.SCHEDULE_DETAILS, [0])}
        >
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: capitalizedFrequency,
                  leftSubTitle: TEXT?.FREQUENCY,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formateDate(
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.transaction_start_date,
                  ),
                  leftSubTitle: globalTextFormat(
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.frequency === "once"
                      ? TEXT?.ON_DATE
                      : TEXT?.FIRST_OCCURRENCES_DATE,
                    [0],
                  ),
                },
              ]}
            />
            {schedulesInternalTxnDetailData?.transaction?.[0]?.frequency !==
              "once" && (
              <>
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: formateDate(
                        schedulesInternalTxnDetailData?.transaction?.[0]
                          ?.transaction_start_date,
                      ),
                      leftSubTitle: globalTextFormat(TEXT?.START_DATE, [0]),
                    },
                  ]}
                />

                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: formateDate(
                        schedulesInternalTxnDetailData?.transaction?.[0]
                          ?.transaction_end_date,
                      ),
                      leftSubTitle: globalTextFormat(TEXT?.END_DATE, [0]),
                    },
                  ]}
                />
              </>
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: schedulesInternalTxnDetailData?.transaction?.[0]
                    ?.slot
                    ? (() => {
                        const [startRaw, endRaw] =
                          schedulesInternalTxnDetailData?.transaction?.[0]?.slot.split(
                            " - ",
                          );

                        const formatTo12Hour = (timeStr) => {
                          const cleaned = timeStr
                            .trim()
                            .replace(/\s?(AM|PM)$/i, "");
                          const [hours, minutes] = cleaned
                            .split(":")
                            .map(Number);
                          const date = new Date();
                          date.setHours(hours);
                          date.setMinutes(minutes);
                          return date.toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          });
                        };

                        return `${formatTo12Hour(startRaw)} - ${formatTo12Hour(endRaw)}`;
                      })()
                    : TEXT?.NOT_AVAILABLE,
                  leftSubTitle: globalTextFormat(TEXT?.TIME_SLOT, [0]),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    schedulesInternalTxnDetailData?.transaction?.[0]
                      ?.occurrences,
                  leftSubTitle: globalTextFormat(TEXT?.OCCURRENCES, [0]),
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default ScheduleInternalTransactionSuccess;
